import { Auth, Customer } from './types/customer.types';
import {
  Chat,
  Form,
  Agent,
  Event,
  Config,
  DynamicConfig,
  Visibility,
  TicketFormSettings,
} from './types';

export type ChatState<
  T = {
    auth: Auth;
    agent: Agent;
    chat: Chat;
    form: Form;
    config: Config;
    dynamicConfig: DynamicConfig;
    ticketFormSettings: TicketFormSettings;
    customer: Customer;
    sessionFieldsTS: number;
    next_page_id?: string;
  },
> = {
  [K in keyof T]: T[K] | undefined;
} & {
  typing: boolean;
  events: Event[];
  visibility: Visibility;
  hasUnseenMessages: boolean;
};

export type LocalizationRequest = {
  group_id: number;
  language: string;
  version: string;
};

export enum ChatAction {
  LOGIN = 'login',
  GET_CHAT = 'get_chat',
  GET_FORM = 'get_form',
  SEND_EVENT = 'send_event',
  SEND_SNEAK_PEEK = 'send_sneak_peek',
  MARK_EVENTS_AS_SEEN = 'mark_events_as_seen',
  START_CHAT = 'start_chat',
  RESUME_CHAT = 'resume_chat',
  LIST_THREADS = 'list_threads',
  INCOMING_CHAT = 'incoming_chat',
  INCOMING_EVENT = 'incoming_event',
  DEACTIVATE_CHAT = 'deactivate_chat',
  CHAT_DEACTIVATED = 'chat_deactivated',
  CUSTOMER_UPDATED = 'customer_updated',
  GET_PREDICTED_AGENT = 'get_predicted_agent',
  CUSTOMER_DISCONNECTED = 'customer_disconnected',
  EVENT_PROPERTIES_UPDATED = 'event_properties_updated',
  UPDATE_CUSTOMER = 'update_customer',
  UPDATE_CUSTOMER_PAGE = 'update_customer_page',
  UPDATE_THREAD_PROPERTIES = 'update_thread_properties',
  INCOMING_TYPING_INDICATOR = 'incoming_typing_indicator',
}
